// TOP LEVEL IMPORTS
import React from 'react';
// ANT
// COMPONENTS
import DownloadPDFButton from 'components/common/DownloadPDFButton';
import PDFHelpers from 'lib/helpers/PDFHelpers/index';

const s = {
  buttonContainer: {
    minHeight: 150,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
};

class InvoiceArea extends React.PureComponent {
  getLineItems = invoice => {
    let keys = invoice.keys;
    let linteItems = [];
    keys.map(key => {
      let item = invoice[`names-${key}`];
      item._id = key;
      linteItems.push(item);
    });
    return linteItems;
  };

  getInvoicePreview = () => {
    let { invoice, client } = this.props;
    let invoiceProps = PDFHelpers.getInvoiceProps({
      client: invoice.client,
      invoice,
      organization: invoice.organization,
    });
    let invoiceHTML = PDFHelpers.getHtmlInvoice(invoiceProps);
    return { __html: invoiceHTML };
  };
  render() {
    const { invoice, currencySymbol } = this.props;

    if (!invoice || !invoice.organization) {
      return null;
    }

    return (
      <div style={{ width: 500, maxWidth: '100%' }}>
        <div dangerouslySetInnerHTML={this.getInvoicePreview()} />
        <div style={s.buttonContainer}>
          <DownloadPDFButton size="large" downloadType="invoice" record={invoice} />
        </div>
      </div>
    );
  }
}

export default InvoiceArea;



// WEBPACK FOOTER //
// ./src/routes/invoice-pay/InvoiceArea/index.js